import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export const ServiceFAQ = ({ faqs }) => {
  const [open, setOpen] = useState(null);

  return (
    <section className="py-24 lg:py-32 bg-[#0c2340]" data-testid="service-faq">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Left side - Title */}
          <div className="lg:col-span-2">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/10 rounded-full px-4 py-2 mb-6">
              <span className="w-2 h-2 bg-[#f97316] rounded-full"></span>
              <span className="text-white/80 font-semibold text-sm">FAQ</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-extrabold text-white leading-tight mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Frequently Asked <span className="text-[#f97316]">Questions</span>
            </h2>
            <p className="text-gray-400 leading-relaxed">
              Find answers to the most common questions about our services. Can't find what you're looking for? Give us a call.
            </p>
            <a href="tel:2368681195" className="inline-flex items-center gap-2 mt-6 text-[#f97316] font-bold text-sm hover:text-[#ea580c] transition-colors">
              (236)868-1195
            </a>
          </div>

          {/* Right side - Accordion */}
          <div className="lg:col-span-3 space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className={`rounded-xl border overflow-hidden transition-all duration-300 ${open === i ? 'bg-white/10 border-[#f97316]/30' : 'bg-white/5 border-white/10 hover:border-white/20'}`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left"
                >
                  <div className="flex items-center gap-4 pr-4">
                    <span className="text-[#f97316] font-bold text-sm min-w-[28px]">0{i + 1}</span>
                    <span className="font-bold text-white text-[15px]">{faq.q}</span>
                  </div>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${open === i ? 'bg-[#f97316]' : 'bg-white/10'}`}>
                    {open === i ? <Minus className="w-4 h-4 text-white" /> : <Plus className="w-4 h-4 text-white" />}
                  </div>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${open === i ? 'max-h-96 pb-5' : 'max-h-0'}`}>
                  <p className="px-6 pl-[70px] text-gray-400 text-sm leading-relaxed">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceFAQ;
